import { render, staticRenderFns } from "./AdjustStockDetail.vue?vue&type=template&id=4585d4c4"
import script from "./AdjustStockDetail.vue?vue&type=script&lang=js"
export * from "./AdjustStockDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports